import React, { Suspense } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import zhCN from 'antd/es/locale/zh_CN';
import 'dayjs/locale/zh-cn';

import { AuthStoreProvider } from '@/context/auth';
import AppRouter from './AppRouter';
import { PageLoading } from '@/component';
import { HeaderSubTitleStoreProvider } from './wrapper/AppLayout/context/HeaderSubTitle';
import { PUBLIC_URL } from '@/env';

export default function App() {
    // 1. 拦截滚轮事件：如果按下了 Ctrl 或 Meta，阻止默认缩放行为
    document.addEventListener('wheel', function (e) {
        if (e.ctrlKey || e.metaKey) {
            e.preventDefault();
        }
    }, { passive: false }); // passive: false 必须加，否则 preventDefault 无效

    // 2. 拦截键盘快捷键：阻止 Ctrl + '+' / '-' / '0' 等按键
    document.addEventListener('keydown', function (e) {
        const ctrl = e.ctrlKey || e.metaKey;
        if (ctrl) {
            // 阻止数字键 0（恢复默认缩放）、加号、减号、等号（实际是加号键）
            if (e.key === '0' || e.key === '-' || e.key === '=' || e.key === '+') {
                e.preventDefault();
            }
        }
    });
    return (
        <Suspense fallback={<PageLoading />}>
            <ConfigProvider locale={zhCN}>
                <BrowserRouter basename={PUBLIC_URL}>
                    <AuthStoreProvider>
                        <HeaderSubTitleStoreProvider>
                            <AppRouter />
                        </HeaderSubTitleStoreProvider>
                    </AuthStoreProvider>
                </BrowserRouter>
            </ConfigProvider>
        </Suspense>
    );

    // return (
    //     <AppLayoutProvider>
    //         <ConfigProvider locale={zhCN}>
    //             <BrowserRouter basename={PUBLIC_URL}>
    //                 {routeElemets}
    //                 {/*
    //             <Router history={history}>
    //                 <AuthStoreProvider>
    //                     <AuthContainer />
    //                 </AuthStoreProvider>
    //
    //                 <UpdateNotify />
    //             </Router>
    //             */}
    //             </BrowserRouter>
    //         </ConfigProvider>
    //     </AppLayoutProvider>
    // );
}
